var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Koo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.103,5.312c-0.06,-0.681 -0.408,-3.24 -2.294,-3.595c-0.452,-0.085 -1.279,0.421 0.587,1.767c-0.204,-0.152 -1.836,-1.323 -2.187,-0.126c-0.086,0.292 -0.28,0.84 1.559,1.349c0,0 -1.565,-0.505 -1.639,0.417c0.495,-0.073 0.995,-0.124 1.507,-0.124c0.846,0 1.669,0.115 2.467,0.312z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.457,19.694c-0.239,-0.795 -0.8,-4.07 -0.8,-4.07c-0.849,-5.47 -4.971,-9.624 -9.94,-9.624c-5.582,0 -10.107,5.24 -10.107,11.704c0,0.44 0.028,0.872 0.07,1.299c0.061,0.006 0.123,0.021 0.181,0.052c2.33,1.185 4.481,5.144 3.577,7.904c-0.485,1.479 -1.908,3.047 -5.759,3.047c-0.809,0 -1.733,-0.074 -2.771,-0.228c-2.176,0.229 -1.682,1.758 -1.682,1.758c1.621,4.864 7.556,6.636 10.295,7.206l1.419,4.258h-1.306c-0.276,0 -0.5,0.224 -0.5,0.5c0,0.276 0.224,0.5 0.5,0.5h1.793l1.854,1.854c0.097,0.097 0.225,0.146 0.353,0.146c0.128,0 0.256,-0.049 0.354,-0.146c0.195,-0.195 0.195,-0.512 0,-0.707l-1.147,-1.147h1.793c0.276,0 0.5,-0.224 0.5,-0.5c0,-0.276 -0.224,-0.5 -0.5,-0.5h-2.64l-1.352,-4.056c0.171,0.025 0.288,0.04 0.288,0.04c2.309,0.385 4.295,0.342 6.015,0.03l0.995,2.986h-1.306c-0.276,0 -0.5,0.224 -0.5,0.5c0,0.276 0.224,0.5 0.5,0.5h1.793l1.854,1.854c0.097,0.097 0.225,0.146 0.353,0.146c0.128,0 0.256,-0.049 0.354,-0.146c0.195,-0.195 0.195,-0.512 0,-0.707l-1.147,-1.147h1.793c0.276,0 0.5,-0.224 0.5,-0.5c0,-0.276 -0.224,-0.5 -0.5,-0.5h-2.64l-1.066,-3.198c3.968,-1.023 6.322,-3.562 7.61,-5.574c1.306,-2.675 2.844,-7.116 0.919,-13.534z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.487,26.647c0.754,-2.303 -1.084,-5.442 -2.799,-6.537c-1.409,1.986 -3.894,5.793 -4.538,8.684c4.079,0.583 6.687,-0.163 7.337,-2.147z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.784,21.48c0.541,3.667 0.376,6.583 -0.141,8.876c4.022,-0.809 3.406,-4.867 0.141,-8.876z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 1,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 16,
    r: 1,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.881,18.306l1.53,-0.755c0.071,-0.035 0.154,-0.034 0.225,0.002l1.474,0.758c0.179,0.092 0.181,0.348 0.004,0.443l-1.447,0.775c-0.072,0.038 -0.157,0.04 -0.23,0.003l-1.557,-0.778c-0.185,-0.093 -0.185,-0.357 0.001,-0.448z",
    fill: "#c62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Koo);
export default __webpack_public_path__ + "static/media/icons8-koo.acb069aa444da78da7adaf1414513947.svg";
export { ForwardRef as ReactComponent };